export const siteName = 'New Hampshire Roads';
export const baseApiPath = 'https://api.nhroads.com/state/nh';